import React, { useState } from 'react'
import "./Tabs.css"
import { useNavigate } from 'react-router';


const Tabs = ({ tabList = [] }) => {

    const [activeTab, setActiveTab] = useState(1)
      const navigate = useNavigate();
    
      const handlesupportticket = () => {
    navigate("/SupportRequest")
  }
    if (!tabList.length) return null;

    const activeTabData = tabList.find(tab => +tab.id === +activeTab);

    return (
        <div className='my-4'>
            {/* <div className='tabs-btn-container' style={{display:"flex", justifyContent:"space-between"}}>
<div>
                    {tabList.map((tab, index) =>
                    <button
                        key={tab?.key || Math.random() + "btn" + index}
                        onClick={() => setActiveTab(tab.id)}
                        className={ ${activeTab === tab.id ? 'active tab-btn' : "tab-btn"}}
                    >
                        {tab?.label}
                    </button>
                )}
</div>
        <div className="need-help-reveue-details">
          <h4 onClick={handlesupportticket}>Need help?</h4>
        </div>
            </div> */}
                <div className="need-help-reveue-details">
        <h4 onClick={handlesupportticket}>Need help?</h4>
    </div>
            <div className='tabs-btn-container' style={{ display: "flex", justifyContent: "space-between" }}>
    <div className="tab-btn-list">
        {tabList.map((tab, index) =>
            <button
                key={tab?.key || Math.random() + "btn" + index}
                onClick={() => setActiveTab(tab.id)}
                className={`${activeTab === tab.id ? 'active tab-btn' : "tab-btn"}`}
            >
                {tab?.label}
            </button>
        )}
    </div>

</div>

            <div className="py-4">
                {activeTabData?.content}
            </div>
        </div>
    )
}

export default Tabs